import React, { Component } from "react";
import LoadingPanel from "../../common/LoadingPanel";
import { toolsController } from "../../../controllers/tools.controller";
import confirmService from "../../common/confirmService";

class KontrolaSpravyDialogContent extends Component {
    state = {
        result: null,
        loading: true
    };

    componentDidMount() {
        toolsController.kontrolaSpravy().then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
            }
            this.setState({
                result: response,
                loading: false
            });
        });
    }

    renderSpravaTypSection = (spravaTyp, spravaNegenerovane) => {
        return (
            <p>
                Kontrola nevygenerovaných správ typu <strong>{spravaTyp}</strong>:{" "}
                {spravaNegenerovane.length > 0 ? (
                    <div className="color-red font-bold">
                        {spravaNegenerovane.map((item) => (
                            <React.Fragment>
                                {item.skratka} (nevygenerované {item.pocet} správ)
                                <br />
                            </React.Fragment>
                        ))}
                    </div>
                ) : (
                    <div className="color-green font-bold">OK</div>
                )}
            </p>
        );
    };

    renderDialogContent() {
        return (
            <div id="KontrolaSpravyDialog">
                {this.renderSpravaTypSection("Expedícia", this.state.result.spravaExpediciaNegenerovane)}
                {this.renderSpravaTypSection("Nahlásenie", this.state.result.spravaNahlasenieNegenerovane)}
                {this.renderSpravaTypSection("Text", this.state.result.spravaTextNegenerovane)}
                {this.renderSpravaTypSection("Avízo", this.state.result.spravaAvizoNegenerovane)}
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderDialogContent();

        return <div>{contents}</div>;
    }
}

export default KontrolaSpravyDialogContent;



// WEBPACK FOOTER //
// ./src/components/views/Tools/KontrolaSpravyDialogContent.js